export default {
  clear: 'Clear the map refinement',
  toggle: 'Search as I move the map',
  redo: 'Redo search here'
};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/es/widgets/geo-search/defaultTemplates.js
// module id = 638
// module chunks = 0